import React from "react";
import { 
  ProjectsContainer,
  ProjectsTitle,
  LeafIcon,
  ProjectsList,
  LoadingContainer,
  LoadingText,
  EmptyContainer,
  EmptyText,
  ProjectButtonWrapper,
  CustomProjectButton
} from "./styles";

const UserProjects = ({ 
  loadingProjects, 
  userProjects, 
  onProjectClick,
  customStyles = {} 
}) => {
  if (loadingProjects) {
    return (
      <LoadingContainer style={customStyles.loadingContainer}>
        <LoadingText style={customStyles.loadingText}>
          Carregando projetos...
        </LoadingText>
      </LoadingContainer>
    );
  }

  if (userProjects.length === 0) {
    return (
      <EmptyContainer style={customStyles.emptyContainer}>
        <EmptyText style={customStyles.emptyText}>
          Nenhum projeto encontrado para este usuário.
        </EmptyText>
      </EmptyContainer>
    );
  }

  return (
    <ProjectsContainer style={customStyles.container}>
      <ProjectsTitle style={customStyles.title}>
        Projetos de Crédito de Carbono
      </ProjectsTitle>

      <LeafIcon 
        style={customStyles.leafIcon}
      />

      <ProjectsList style={customStyles.projectsList}>
        {userProjects.map((project) => (
          <ProjectButtonWrapper key={project.id}>
            <CustomProjectButton
              onClick={() => onProjectClick(project)}
              style={customStyles.projectButton}
            >
              {project.title?.toUpperCase() || "PROJETO SEM TÍTULO"}
            </CustomProjectButton>
          </ProjectButtonWrapper>
        ))}
      </ProjectsList>
    </ProjectsContainer>
  );
};

export default UserProjects;